module.exports = __webpack_public_path__ + "static/img/ELENA_PONIATOWSKA.ec3ecdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/ELENA_PONIATOWSKA.jpg
// module id = t4ke
// module chunks = 1